import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AuthVerify from '../../components/Templates/Site/AuthVerify';
import { useSelector } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import SidePanelRolesProfiles from '../../components/Products/sKPI/Board/BoardElementsConfigBox/SidePanelRolesProfiles';
import * as actionsElement from '../../actions/privilegeElement-action';
import * as actionsParty from '../../actions/privilegeParty-action';
import * as actionsPartyMember from '../../actions/privilegePartyMember-action';
import { useGetPrivileges } from '../../hooks/services/sRoles/useOfPrivileges';
import { ActionButton, ConstrainMode, DetailsListLayoutMode, OverflowSet, Selection, SelectionMode, ShimmeredDetailsList, TooltipHost, TooltipOverflowMode, mergeStyleSets } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import DisabledCard from '../../components/Templates/CCard/DisabledCard';
import NoDataLayer from '../../components/Common/NoDataLayer';
import Message from '../../components/Common/Message';
import CLabel from '../../components/Common/CLabel';
import CardNemoItem from '../../components/Products/sBook/PartyCreationBox/CardNemoItem';


function RolesCreation({itemElement, itemPartys, itemPartyMembers, actionsElementConnect, actionsPartyConnect, actionsPartyMemberConnect}) {
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);


    const [element, setElement] = useState(null);
    const [partys, setPartys] = useState([]);
    const [partymembers, setPartymembers] = useState([]);

    const [isAddRolesPanelOpen, setAddRolesPanelOpen] = useState(false);
    const [elementIdSelected, setElementIdSelected] = useState(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const { elementId } = useParams();
    const elementIdAux = parseInt(elementId);

    useGetPrivileges(elementIdAux, element,setElement, partys, setPartys, partymembers, setPartymembers);


    useEffect(() => {
        
        if (element) {
            actionsElementConnect.setPrivilegeElement(element);
            actionsPartyConnect.setPrivilegePartys(partys);
            actionsPartyMemberConnect.setPrivilegePartyMembers(partymembers);
        }
        
    
      }, [element, actionsElementConnect, actionsPartyConnect, actionsPartyMemberConnect]);

    const onOpenAddRolesPanel = (elementId) => {
        setAddRolesPanelOpen(true)
        setElementIdSelected(elementId)
    };

    const onUpdateElementRoleCount = (data) => {
        setPartymembers(data);
        actionsPartyMemberConnect.setPrivilegePartyMembers(partymembers);
    };

    let _selection = new Selection();

    const _columns = [
        {            
            key: 'username',            
            name: t('data-lang-lbl-username'),
            fieldName: 'username',
            minWidth: 100,
            maxWidth: 170,
            onRender:(item) => {
                return  <TooltipHost content={ item.username } >
                            <div>{ item.fullname }</div>
                        </TooltipHost>  
            }
        },
        {
            key: 'partyName',            
            name: t('data-lang-lbl-partyname'),
            fieldName: 'partyName',
            minWidth: 100,
            maxWidth: 170,
            onRender:(item) => {
                return  <TooltipHost content={ item.partyName } >
                            <div>{ item.partyName }</div>
                        </TooltipHost>  
            }
        },
        {
            key: 'roleName',            
            name: t('data-lang-lbl-rolename'),
            fieldName: 'roleName',
            minWidth: 100,
            maxWidth: 170,
            onRender:(item) => {
                return  <TooltipHost
                            content={ item.roleName }
                            overflowMode={TooltipOverflowMode.Self}                            
                            onTooltipToggle={false}
                            styles={{
                                root: { display: 'block', minWidth: "80px", width: "180px" },
                            }}
                        >
                            <div>
                                {item.roleName}
                            </div>
                        </TooltipHost> 
            }
        },
        // {  
        //     key: 'id',
        //     fieldName: 'username',
        //     maxWidth: 500,
        //     onRender:(userPermission, row) => {

        //         let itemsOrdered = userPermission.items.sort(function(a, b) { return a.sectionName.localeCompare(b.sectionName) })

        //         return <table style={{width: "100%"}}>
        //                     <thead>
        //                         <tr>
        //                             <td style={{minWidth: "80px", width: "180px"}}>
        //                                 {t('data-lang-lbl-party')}
        //                             </td>
        //                             <td style={{width: "70px"}}>
        //                                 {t('data-lang-lbl-role')}
        //                             </td>                                    
        //                             <td style={{width: "70px"}}>
        //                                 {t('data-lang-lbl-actions')}
        //                             </td>
        //                         </tr>
        //                     </thead>
        //                     <tbody>
        //                         {
        //                             itemsOrdered.map((userPermissionOrdered, index) => (
        //                                 <tr key={index}>
        //                                     <td>
        //                                         <TooltipHost
        //                                             content={ userPermissionOrdered.partyName }
        //                                             overflowMode={TooltipOverflowMode.Self}
        //                                             hostClassName={css(classNames.overflow)}
        //                                             onTooltipToggle={false}
        //                                             styles={{
        //                                                 root: { display: 'block', minWidth: "80px", width: "180px" },
        //                                             }}
        //                                         >
        //                                             <div>
        //                                                 {userPermissionOrdered.partyName}
        //                                             </div>
        //                                         </TooltipHost>
        //                                     </td>                                            
        //                                     <td>
        //                                         {userPermissionOrdered.roleName}
        //                                     </td>                                           
                                            
        //                                     <td>
        //                                         <div>
        //                                             <OverflowSet
        //                                                 className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
        //                                                 role="menubar"
        //                                                 items={[
        //                                                     {
        //                                                         key: 'delete',
        //                                                         icon: 'Delete',
        //                                                         name: t('data-lang-btn-delete'),
        //                                                         title: t('data-lang-btn-delete'),
        //                                                         //onClick: () => onDeleteUserFromBookClick(userPermissionOrdered),
        //                                                     },
        //                                                     {
        //                                                         key: 'enabledisable',
        //                                                         icon: userPermissionOrdered.deactivate ? 'Blocked' : 'SkypeCircleCheck',
        //                                                         name: userPermissionOrdered.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable'),
        //                                                         title: userPermissionOrdered.deactivate ? t('data-lang-btn-enable') : t('data-lang-btn-disable'),
        //                                                         //onClick: () => onDisableUserFromBookClick(userPermissionOrdered),
        //                                                     }
        //                                                 ]}
        //                                                 // onRenderOverflowButton={__onRenderOverflowButton}
        //                                                 // onRenderItem={__onRenderOverflowItem}
        //                                             />
        //                                         </div>
        //                                     </td>
                                            
        //                                 </tr>
        //                             ))
        //                         }
        //                     </tbody>
                            

        //                 </table>
        //     }
        // }
    ];

    const inputParam_Styles = {root: { zIndex: -2 }};
    const fontSize = { fontSize: "13px" }

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            <Row className="pb-2" style={{ display: "none"}}>
                <Col>
                    <Card className='book-info-form'>
                        <Card.Body className="book-info-form-body">
                            <Row>
                                <div className="col-9 col-sm-10 col-xl-11">
                                    status bar 1345 aaaaaaaaaaa ok funciona
                                </div>
                                <div className="col-3 col-sm-2 col-xl-1 pt-sm-3">
                                    over flow set oka
                                </div>
                            </Row>
                            <Row>
                                <div style={{position: "absolute", width: "260px", right: "16px", marginTop: "-6px"}} className='pt-2'>
                                    message de prueba
                                </div>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Row className="pb-2">
                <Col lg={12} xl={5} className="pe-2">
                <div style={{ height: '100%' }}>
                        <Card className='h-100'>
                            <Card.Header className="card-header-compact">
                                <Card.Title className="justify-content-between">
                                    <Row>                                        
                                        <Col className={ true ? "ps-4 ms-3" : "" } >
                                            <b>{t('data-lang-boxname-elementinformation')}</b>
                                        </Col>
                                    </Row>
                                </Card.Title>
                            </Card.Header>
                            <Card.Footer className='px-0' style={{borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                                
                            </Card.Footer>
                            
                            
                                {
                                    element &&
                                    <Card.Body className="small-card-body h-100">
                                        <Row>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-name') } labelValue={ element.name } />
                                            </Col>
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-code') } labelValue={ element.code } />
                                            </Col>                                        
                                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                                <CLabel labelText={ t('data-lang-lbl-type') } labelValue={ element.typeId == 1 ? t('data-lang-btn-etype-contract') : t('data-lang-btn-etype-otro') } />
                                            </Col>                                        
                                        </Row>
                                    
                                        
                                    </Card.Body>
                                }
                            <Card.Footer>
                                
                            </Card.Footer>
                        </Card>
                    </div>
                    <Row className="pb-2 d-xs-none d-sm-block d-block d-sm-none">
                    </Row>
                    <Row className="pb-0 d-xs-none d-sm-block d-none d-sm-block">
                    </Row>
                </Col>
                <Col className="ps-0 pe-4">
                <div style={{ height: '100%' }}>
                    
                        <Card className='book-partys-form h-100'>
                            <DisabledCard display={ false } />
                            <Card.Header className="card-header-compact">
                                <Card.Title className="d-flex justify-content-between">
                                    <Row>                                    
                                        <Col className={ true ? "ps-4 ms-3" : "" } >
                                            <b>{t('data-lang-boxname-partys')}</b>
                                        </Col>
                                    </Row>
                                </Card.Title>
                            </Card.Header>                            
                            <Card.Body className="book-partys-form-body pt-2 w-100 h-100">
                                <Row className='layerBlockedContent'>
                                    {
                                        partys && partys.map((party, index) => 
                                            <Col className={`mb-2`} key={ index } xs={12} sm={12} md={6} lg={6} xl={6} xxl={4}>
                                                <Card key={party.id} className={`${true ? (false ? "selected-card" : "") : ""}`}>
                                                    <Card.Body className="card-party p-1">                                
                                                        <div className='d-flex' style={{cursor: true ? "pointer" : "default"}}>
                                                        <Col style={fontSize} className="card-party-title">
                                                            <h5>
                                                                <CardNemoItem text={ party.name.charAt(0) } />
                                                            </h5>
                                                        </Col>
                                                        <Col style={fontSize} className="card-party-body">
                                                            <Row>
                                                                <Col>
                                                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-code') } labelValue={ party.elementPartyCode }  />
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col>
                                                                    <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-name') } labelValue={ party.name } />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        </div>
                                                    </Card.Body>
                                                    <Card.Footer className='p-0'>
                                                        
                                                    </Card.Footer>
                                                    
                                                </Card>
                                            </Col>
                                        )
                                    }
                                    <NoDataLayer display={ false } />
                                </Row>
                            </Card.Body>
                            <Card.Footer>
                                
                            </Card.Footer>
                        </Card>
                        </div>
                
                </Col>
            </Row>
            <Row className='pe-2'>
                <Col className="pb-2 pe-1" lg={12} xl={12}>                    
                    <Card className='h-100'>
                        <DisabledCard display={ false } />
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                                <b>{t('data-lang-boxname-roles')}</b>
                            </Card.Title>
                        </Card.Header>
                        <Card.Footer style={{ display: "block", padding: "0px", minHeight:"46px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }} >
                            <div className='book-toolbar d-flex float-end'>
                                <ActionButton onClick={() => onOpenAddRolesPanel(element.id)} iconProps={{ iconName: 'EntryView' }} allowDisabledFocus >{`${t('data-lang-lbl-view')} (${partymembers ? partymembers.length :  0})`}</ActionButton>
                                {
                                    isAddRolesPanelOpen &&
                                    <SidePanelRolesProfiles
                                        inputParam_IsPanelOpen={isAddRolesPanelOpen}
                                        inputParam_SetterIsPanelOpen={setAddRolesPanelOpen}
                                        inputParam_EditMode={true}
                                        inputParam_Element={element}
                                        inputParam_OnUpdateElementRoleCount={onUpdateElementRoleCount}
                                        inputParam_ElementType={element.typeId}                                                               
                                        inputParam_GridSetterEnabled={false}
                                    />
                                } 
                            </div>
                        </Card.Footer>
                        <Card.Body style={{width: "100%"}} className="overflow-auto h-100">         
                            <Row className='layerBlockedContent'>
                                <Col>
                                    {
                                        partymembers &&                                        
                                            
                                        <ShimmeredDetailsList
                                            items={ partymembers }
                                            setKey="set"
                                            columns={_columns}
                                            selection={_selection}
                                            selectionMode={SelectionMode.none}
                                            layoutMode={DetailsListLayoutMode.justified}
                                            enableShimmer={ false }
                                            constrainMode={ConstrainMode.horizontalConstrained}                                            
                                            className="no-compact-list big-header"
                                            isHeaderVisible={true}
                                            columnReorderOptions={ undefined}
                                            styles={inputParam_Styles}
                                        /> 
                                        
                                    }
                                    <NoDataLayer display={ false } />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>                   
                </Col>
            </Row>
        </>
    ); 
}

RolesCreation.propTypes = {
    itemElement: PropTypes.shape({        
        id: PropTypes.number,
        name: PropTypes.string,        
    }),
    itemPartys: PropTypes.arrayOf(PropTypes.object),
    itemPartyMembers: PropTypes.arrayOf(PropTypes.object),
    actionsElementConnect: PropTypes.shape({        
        setPrivilegeElement: PropTypes.func,      
    }),
    actionsPartyConnect: PropTypes.shape({
        setPrivilegePartys: PropTypes.func,      
    }),
    actionsPartyMemberConnect: PropTypes.shape({
        setPrivilegePartyMembers: PropTypes.func,      
    }),
  };

const mapStateToProps = state => ({    
    itemElement: state.privilegeElement.itemElement,
    itemPartys: state.privilegePartys.itemPartys,
    itemPartyMembers: state.privilegePartyMembers.itemPartyMembers
  });
  
  const mapDispatchToProps = dispatch => ({
    actionsElementConnect: bindActionCreators(actionsElement, dispatch),
    actionsPartyConnect: bindActionCreators(actionsParty, dispatch),
    actionsPartyMemberConnect: bindActionCreators(actionsPartyMember, dispatch),
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(RolesCreation);

